import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import {NevigationProvider} from './Utils/Nevigation/NevigationProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <NevigationProvider>
    <App />
  </NevigationProvider>
);
